var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSaudiArabia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04309 19.1411C9.04309 20.2937 9.97747 21.2281 11.13 21.2281H17.3909C17.3909 22.1886 18.1695 22.9672 19.13 22.9672H21.217C22.1775 22.9672 22.9561 22.1886 22.9561 21.2281V19.1411H9.04309Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1296 9.0542V13.9238C23.1296 14.6909 22.5055 15.3151 21.7383 15.3151V17.402C23.6562 17.402 25.2165 15.8416 25.2165 13.9238V9.0542H23.1296Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17354 13.9238C8.17354 14.6909 7.54941 15.3151 6.78223 15.3151V17.402C8.70016 17.402 10.2605 15.8416 10.2605 13.9238V9.0542H8.17354V13.9238Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.0542H22.0869V13.9238H20V9.0542Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8689 11.8368C16.8689 12.0286 16.7128 12.1846 16.5211 12.1846C16.3293 12.1846 16.1733 12.0286 16.1733 11.8368V9.0542H14.0863V11.8368C14.0863 12.0286 13.9303 12.1846 13.7385 12.1846C13.5468 12.1846 13.3907 12.0286 13.3907 11.8368V9.0542H11.3037V11.8368C11.3037 13.1794 12.396 14.2716 13.7385 14.2716C14.2556 14.2716 14.7351 14.1091 15.1298 13.8331C15.5245 14.1091 16.0041 14.2716 16.5211 14.2716C16.6253 14.2716 16.7276 14.2643 16.8283 14.2515C16.6805 14.8608 16.1317 15.3151 15.4776 15.3151V17.402C17.3956 17.402 18.9559 15.8416 18.9559 13.9238V11.8368V9.0542H16.869V11.8368H16.8689Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3037 15.3152H14.4341V17.4021H11.3037V15.3152Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSaudiArabia);
export default __webpack_public_path__ + "static/media/flag_saudi_arabia.04f54c574b2318b9d1fad104f8f08d25.svg";
export { ForwardRef as ReactComponent };